'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var Main = styled__default.div(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  /* position: fixed; */\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  & > button {\n    svg {\n      height: 24px;\n      width: 24px;\n    }\n  }\n"], ["\n  /* position: fixed; */\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  & > button {\n    svg {\n      height: 24px;\n      width: 24px;\n    }\n  }\n"])));
var templateObject_1;

exports.Main = Main;
